import React from 'react';
import { defaultReactionsConfig } from '../../../common/constants/config-defaults';
import { useApi } from '../api-context/use-api';
import { ConfigurationContext } from './configuration-context';
import { LikeHeart } from '@wix/wix-ui-icons-common/on-stage';
function ConfigurationProvider(props) {
    const ctx = useApi((_state, _actions, _host, ctx) => ctx);
    // defensive here as we're not 100% sure that api provider is always present
    const devToolsState = ctx?.wcDevToolsState ?? {};
    const config = React.useMemo(() => {
        const { reactions = {}, ...consumerConfig } = props.config;
        const devReactionsConfig = {
            ...(devToolsState.commentReactions === 'auto'
                ? {}
                : { commentReactions: { type: devToolsState.commentReactions } }),
            ...(devToolsState.replyReactions === 'auto'
                ? {}
                : { replyReactions: { type: devToolsState.replyReactions } }),
        };
        const hideHeader = devToolsState.hideHeader === 'auto'
            ? consumerConfig.hideHeader
            : devToolsState.hideHeader === 'on';
        const hideSorting = devToolsState.hideSorting === 'auto'
            ? consumerConfig.hideSorting
            : devToolsState.hideSorting === 'on';
        const hideTitle = devToolsState.hideTitle === 'auto'
            ? consumerConfig.hideTitle
            : devToolsState.hideTitle === 'on';
        const result = {
            pagination: props.config.pagination,
            reactions: { ...defaultReactionsConfig, ...reactions, ...devReactionsConfig },
            // defaults cutoff
            ...consumerConfig,
            commentBoxPosition: devToolsState.commentBoxPosition === 'auto'
                ? consumerConfig.commentBoxPosition
                : devToolsState.commentBoxPosition,
            hideHeader,
            hideSorting,
            hideTitle,
            hideReplyingTo: devToolsState.hideReplyingTo === 'auto'
                ? consumerConfig.hideReplyingTo
                : devToolsState.hideReplyingTo === 'on',
            hidePublishDate: devToolsState.hidePublishDate === 'auto'
                ? consumerConfig.hidePublishDate
                : devToolsState.hidePublishDate === 'on',
            hideAvatars: devToolsState.hideAvatars === 'auto'
                ? consumerConfig.hideAvatars
                : devToolsState.hideAvatars === 'on',
            hideBadge: devToolsState.hideBadge === 'auto'
                ? consumerConfig.hideBadge
                : devToolsState.hideBadge === 'on',
            hideHeaderDivider: devToolsState.hideHeaderDivider === 'auto'
                ? consumerConfig.hideHeaderDivider
                : devToolsState.hideHeaderDivider === 'on',
            isLocked: devToolsState.isLocked === 'auto'
                ? consumerConfig.isLocked
                : devToolsState.isLocked === 'on',
            hideZeroCommentsEmptyState: devToolsState.hideZeroCommentsEmptyState === 'auto'
                ? consumerConfig.hideZeroCommentsEmptyState
                : devToolsState.hideZeroCommentsEmptyState === 'on',
            blackAndWhiteModals: devToolsState.blackAndWhiteModals === 'auto'
                ? consumerConfig.blackAndWhiteModals
                : devToolsState.blackAndWhiteModals === 'on',
            markLabels: devToolsState.markLabels === 'auto'
                ? consumerConfig.markLabels
                : devToolsState.markLabels === 'on'
                    ? {
                        markActionLabel: 'Custom mark as text',
                        unmarkActionLabel: 'Custom unmark text',
                        badgeLabel: 'Custom badge label',
                        icon: { type: 'CUSTOM', icon: LikeHeart },
                    }
                    : devToolsState.markLabels === 'no-icon'
                        ? {
                            markActionLabel: 'Custom mark as text',
                            unmarkActionLabel: 'Custom unmark text',
                            badgeLabel: 'Custom badge label',
                            icon: { type: 'NONE' },
                        }
                        : undefined,
            ratings: devToolsState.ratings.type === 'auto'
                ? consumerConfig.ratings
                : devToolsState.ratings.type === 'on'
                    ? { isRequired: devToolsState.ratings.isRequired }
                    : undefined,
            userAuthDisplay: consumerConfig.userAuthDisplay ?? 'LOGOUT_ONLY',
        };
        return result;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.config.isLocked,
        props.config.resourceId,
        props.config.reactions,
        props.config.hideHeader,
        props.config.hideTitle,
        props.config.hideHeaderDivider,
        props.config.hideSorting,
        props.config.hideZeroCommentsEmptyState,
        props.config.overlayLayerContainer,
        props.config.disableNavigationPrompt,
        props.config.transformCommentOnRender,
        props.config.renderAuthorRole,
        props.config.blackAndWhiteModals,
        props.config.markLabels,
        devToolsState,
    ]);
    return (React.createElement(ConfigurationContext.Provider, { value: config }, props.children));
}
export default React.memo(ConfigurationProvider);
//# sourceMappingURL=configuration-provider.js.map